document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".featured-collection-tab");
  const tabContents = document.querySelectorAll(".tab-content");
  const viewMoreButtons = document.querySelectorAll(".view-more-btn");

  // Initialize custom scrollbar pagination
  function initCustomPagination(splide, splideEl) {
    const scrollbar = splideEl.querySelector("#customScrollbar");
    const thumb = splideEl.querySelector("#scrollbarThumb");

    if (!scrollbar || !thumb) return;

    splide.on("mounted move", () => {
      const totalSlides = splide.length;
      const currentPerPage = splide.options.perPage;

      if (totalSlides <= currentPerPage) {
        scrollbar.style.display = "none";
        return;
      }

      scrollbar.style.display = "block";
      const thumbWidth = (currentPerPage / totalSlides) * 100;
      const activeIndex = splide.index;
      const maxIndex = totalSlides - currentPerPage;
      const thumbPosition =
        maxIndex > 0 ? (activeIndex / maxIndex) * (100 - thumbWidth) : 0;

      thumb.style.width = `${thumbWidth}%`;
      thumb.style.left = `${Math.max(
        0,
        Math.min(thumbPosition, 100 - thumbWidth)
      )}%`;
    });

    let isDragging = false;
    let startX;

    const onMouseMove = (e) => {
      if (!isDragging) return;
      const deltaX = e.clientX - startX;
      const scrollbarWidth = scrollbar.offsetWidth;
      const thumbWidthPx = thumb.offsetWidth;
      let left =
        (parseFloat(thumb.style.left || 0) * scrollbarWidth) / 100 + deltaX;
      left = Math.max(0, Math.min(scrollbarWidth - thumbWidthPx, left));
      thumb.style.left = `${(left / scrollbarWidth) * 100}%`;
      startX = e.clientX;
      const totalSlides = splide.length;
      const currentPerPage = splide.options.perPage;
      const maxLeft = scrollbarWidth - thumbWidthPx;
      const percentage = maxLeft > 0 ? left / maxLeft : 0;
      const index = Math.round(percentage * (totalSlides - currentPerPage));
      splide.go(Math.max(0, Math.min(index, totalSlides - currentPerPage)));
    };

    const onMouseUp = () => {
      isDragging = false;
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
      document.body.style.cursor = "";
    };

    const onTouchMove = (e) => {
      if (!isDragging) return;
      const deltaX = e.touches[0].clientX - startX;
      const scrollbarWidth = scrollbar.offsetWidth;
      const thumbWidthPx = thumb.offsetWidth;
      let left =
        (parseFloat(thumb.style.left || 0) * scrollbarWidth) / 100 + deltaX;
      left = Math.max(0, Math.min(scrollbarWidth - thumbWidthPx, left));
      thumb.style.left = `${(left / scrollbarWidth) * 100}%`;
      startX = e.touches[0].clientX;
      const totalSlides = splide.length;
      const currentPerPage = splide.options.perPage;
      const maxLeft = scrollbarWidth - thumbWidthPx;
      const percentage = maxLeft > 0 ? left / maxLeft : 0;
      const index = Math.round(percentage * (totalSlides - currentPerPage));
      splide.go(Math.max(0, Math.min(index, totalSlides - currentPerPage)));
    };

    const onTouchEnd = () => {
      isDragging = false;
      document.removeEventListener("touchmove", onTouchMove);
      document.removeEventListener("touchend", onTouchEnd);
    };

    thumb.addEventListener("mousedown", (e) => {
      isDragging = true;
      startX = e.clientX;
      e.preventDefault();
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
      document.body.style.cursor = "grabbing";
    });

    thumb.addEventListener("touchstart", (e) => {
      isDragging = true;
      startX = e.touches[0].clientX;
      e.preventDefault();
      document.addEventListener("touchmove", onTouchMove);
      document.addEventListener("touchend", onTouchEnd);
    });
  }

  // Initialize all splides
  function initSplide(splideEl) {
    if (!splideEl || splideEl.classList.contains("is-initialized")) return;
    if (window.Splide) {
      const autoplay = splideEl.dataset.autoplay === "true";
      const interval = parseInt(splideEl.dataset.autoplaySpeed) || 3000;
      const showArrows = splideEl.dataset.showArrows === "true";
      const showArrowsMobile = splideEl.dataset.showArrowsMobile === "true";
      const showDots = splideEl.dataset.showDots === "true";
      const showDotsMobile = splideEl.dataset.showDotsMobile === "true";

      const splide = new Splide(splideEl, {
        type: "slide",
        drag: true,
        gap: "1rem",
        perPage: 4,
        perMove: 1,
        pagination: false,
        arrows: showArrows,
        autoplay: autoplay,
        interval: interval,
        pauseOnHover: true,
        speed: 800,
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        focus: 0,
        updateOnMove: true,
        rewind: false,
        breakpoints: {
          1025: {
            perPage: 2,
            gap: "0.8rem",
            speed: 600,
            arrows: showArrowsMobile,
            pagination: false,
          },
          750: {
            perPage: 2,
            gap: "0.4rem",
            speed: 600,
            padding: { right: "8%" },
            arrows: showArrowsMobile,
            pagination: false,
          },
          480: {
            perPage: 1.3,
            gap: "0.4rem",
            speed: 600,
            padding: { right: "8%" },
            arrows: showArrowsMobile,
            pagination: false,
          }
        },
      });

      // Initialize custom scrollbar pagination
      initCustomPagination(splide, splideEl);

      splide.mount();
      splideEl.classList.add("is-initialized");
    }
  }
  // Init first visible Splide
  tabContents.forEach((tabContent) => {
    if (tabContent.classList.contains("active-tab")) {
      const splideEl = tabContent.querySelector(".splide");
      initSplide(splideEl);
    }
  });
  // Handle tab switching
  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const tabId = this.dataset.tabId;
      // Reset all tabs
      tabButtons.forEach((btn) => {
        btn.classList.remove("active-collection-tab");
        btn.setAttribute("aria-selected", "false");
      });
      // document.querySelectorAll('.techit-animate .on')?.forEach((el) => { el.classList.remove('on'); });
      tabContents.forEach((content) => content.classList.add("hidden"));
      viewMoreButtons.forEach((btn) => btn.classList.add("hidden"));
      // Activate selected tab + button + view more
      this.classList.add("active-collection-tab");
      this.setAttribute("aria-selected", "true");
      const activeContent = document.querySelector(`#tab-${tabId}`);
      if (activeContent) {
        activeContent.classList.remove("hidden");
        activeContent.classList.add("active-tab");
        const splideEl = activeContent.querySelector(".splide");
        initSplide(splideEl); /*
        activeContent.querySelectorAll('.techit-animate').forEach((el, i) => {
          el.style.transitionDelay = `${i * 0.12}s`;
          el.classList.add('on');
        }); */
      }
      const activeViewMore = document.querySelectorAll(
        `.view-more-btn[data-tab-id="${tabId}"]`
      );
      activeViewMore.forEach((btn) => {
        btn.classList.remove("hidden");
        btn.classList.add("active-button");
      });
    });
  });
});
